import BaseApi from "../baseApi";
import {PROJECT} from "../apiConstant";

const apiWorkManage = new BaseApi(process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL);

class ProjectApi {
  createProject(request) {
    return apiWorkManage.post(`${PROJECT}/create`, request);
  }

  updateProject(request) {
    return apiWorkManage.post(`${PROJECT}/update`, request);
  }

  getList(request) {
    return apiWorkManage.post(`${PROJECT}/list`, request);
  }

  getProjectDetail(projectCode) {
    return apiWorkManage.get(`${PROJECT}/detail/${projectCode}`);
  }

  changeProjectBookmark(projectCode) {
    return apiWorkManage.post(`${PROJECT}/bookmark/${projectCode}`);
  }

  deleteProject(projectCode) {
    return apiWorkManage.post(`${PROJECT}/delete/${projectCode}`);
  }

}

export default ProjectApi;